import axios from '@/api/requests/axios'

export default {
  get: () => axios.get('/api/admin/v1/notification-settings'),
  updateMobilePush: settings => axios.put('/api/admin/v1/notification-settings/mobile-push', settings),
  updateWebPush: settings => axios.put('/api/admin/v1/notification-settings/web-push', settings),
  updateSms: settings => axios.put('/api/admin/v1/notification-settings/sms', settings),
  updateCampaigns: settings => axios.put('/api/admin/v1/notification-settings/campaigns', settings),

  updateTemplate: template => axios.put('/api/admin/v1/notification-settings/templates', template),
  sendTestPush: customerId => axios.post('/api/admin/v1/notification-settings/test-push', { customerId }),

  getTestPushCustomers: params => axios.get('/api/admin/v1/notification-settings/test-push/customers', { params }),
  sendTestSms: phoneNumber => axios.post('/api/admin/v1/notification-settings/test-sms', { phoneNumber }),

  getEvents: () => axios
    .get('/api/admin/v1/notification-settings/events', {
      validateStatus: status => (status >= 200 && status < 300) || status === 404,
    })
    .then(response => (response.status === 404 ? Promise.reject(new Error('events are not supported')) : response)),

  updateEvent: (code, event) => axios
    .put(`/api/admin/v1/notification-settings/events/${encodeURIComponent(code)}`, event),

  sendTestEvent: (code, customerId) => axios
    .post(`/api/admin/v1/notification-settings/events/${encodeURIComponent(code)}/test`, { customerId }),
}
